import { FormConfig, FormValues, NextFunction } from '@topdanmark-onlinesolutions/claim-form-types';
import { getValueOrDefault } from '../components/values/Get';

export const getNextPage: NextFunction = async (
    curPageId: string,
    formConfig: FormConfig,
    formValues: FormValues
): Promise<string | undefined> => {
    let nextPage: string | undefined = '';
    switch (curPageId) {
        case 'godt-at-vide':
            nextPage = 'dato';
            break;
        case 'dato':
            nextPage = 'adresse';
            break;
        case 'adresse':
            nextPage = 'skadebeskrivelse';
            break;
        case 'skadebeskrivelse':
            nextPage = 'dokumentation';
            break;
        case 'dokumentation':
            nextPage = 'andet-selskab';
            break;
        case 'andet-selskab':
            if (
                getValueOrDefault(formConfig, formValues, 'harduenforsikringietandetselskabsomdkkerdetsamme').value ===
                'Ja'
            ) {
                nextPage = 'hvilket-selskab';
            } else {
                nextPage = 'om-dig';
            }
            break;
        case 'hvilket-selskab':
            nextPage = 'om-dig';
            break;
        case 'om-dig':
            nextPage = 'resume';
            break;
        default:
            throw new Error('Unknown page: ' + curPageId);
    }
    return nextPage;
};
